<template>
  <div>
    <div class="grid lg:grid-cols-3 grid-cols-1 lg:gap-5 gap-y-5 m-3">
      <div class="bg-white rounded-lg col-span-2">
        <div class="border-b-0.5 flex justify-between items-center p-3">
          <p class="text-sm font-semibold">Check In</p>
          <div class="flex gap-5">
            <div
              class="flex items-center gap-1 text-xs"
              v-for="(key, index) in calendarKey"
              :key="index"
            >
              <div :class="key.color" class="h-3 w-3 rounded-full"></div>
              <p>{{ key.key }}</p>
            </div>
          </div>
        </div>
        <div class="p-3 flex gap-3">
          <div class="lg:block hidden">
            <vc-date-picker v-model="date" />
          </div>

          <div class="bg-gray-100 rounded-md w-full">
            <div class="border-b-0.5">
              <p class="p-3 text-sm">Clock In</p>
            </div>

            <transition name="fade">
              <div
                v-if="create_error"
                class="p-1 text-center text-sm w-full bg-yellow-200"
              >
                {{ create_error }}
              </div>
            </transition>

            <transition name="fade">
              <div
                v-if="success"
                class="p-1 text-center text-sm w-full bg-green-200"
              >
                {{ success }}
              </div>
            </transition>

            <div class="flex flex-col gap-1 justify-center p-4 items-center">
              <span
                v-if="!isUseClockedIn"
                class="text-center lg:text-5xl text-4xl font-bold border-1.5 p-3.5 rounded-lg"
                >{{ time }}</span
              >
              <span
                v-if="isUseClockedIn"
                class="text-center text-md font-bold border-1.5 p-3.5 rounded-lg"
                >You clocked in
                <br />
                {{ timeSinceClockIn }}</span
              >
              <button
                @click="handleClockIn"
                v-if="!isUseClockedIn"
                class="bg-green-500 text-white rounded-full text-sm lg:w-1/3 w-full p-2 mt-4"
              >
                Clock In
              </button>
              <button
                @click="handleClockOut"
                v-if="isUseClockedIn"
                class="bg-red-500 text-white rounded-full text-sm lg:w-1/3 w-full p-2 mt-4"
              >
                Clock Out
              </button>
            </div>
          </div>

          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
        </div>
      </div>
      <div class="col-span-1 w-full bg-white rounded-md">
        <div class="border-b-0.5 flex justify-between items-center p-3">
          <p class="text-sm font-semibold">Summary</p>
          <div
            class="text-sm font-semibold rounded capitalize flex px-1.5 py-0.5 gap-1 justify-center"
            style="border: 1.5px solid #bfbfbf; align-items: center"
          >
            <img src="@/assets/icons/calendar.svg" class="h-4" alt="" />
            <p>weekly</p>
          </div>
        </div>
        <div class="flex flex-col gap-2 m-3">
          <div
            class="border-1.5 rounded p-2"
            v-for="(item, index) in summary"
            :key="index"
          >
            <div class="flex justify-between items-center w-full">
              <p class="text-xs font-semibold">{{ item.name }}</p>
              <p class="text-green-500">{{ item.value }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-md m-3 p-3, text-xs">
      <ve-table :columns="columns" :table-data="tableData" />
      <div
        v-if="!loading && tableData.length === 0"
        class="flex flex-col justify-center items-center h-full mt-5"
      >
        <el-empty :image-size="70" description="No Data"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
// import mapboxgl from "mapbox-gl";
// import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

export default {
  name: "mine",
  components: { Loader },
  props: ["myAttendance"],
  data() {
    return {
      clockInLocation: "",
      clockOutLocation: "",
      date: new Date(),
      timeElapsed: null,
      location: null,
      success: null,
      create_error: null,
      loading: false,
      MyAttendance: null,
      TeamAttendance: null,
      lat: null,
      long: null,
      currTime: moment().format("h:mm:ss A"),
      calendarKey: [
        { key: "Present", color: "bg-green-500" },
        { key: "Absent", color: "bg-red-500" },
        { key: "Leave", color: "bg-gray-500" },
        { key: "Late", color: "bg-yellow-500" },
      ],
      summary: [
        { name: "Work Schedule", value: "50 Hrs" },
        { name: "Logged Time", value: "50 Hrs" },
        { name: "Paid Time", value: "50 Hrs" },
        { name: "Deficit", value: "-3 Hrs" },
        { name: "Overtime", value: "30 Hrs" },
      ],
      columns: [
        {
          field: "Date",
          key: "a",
          title: "Date In",
          renderBodyCell: ({ row }) => {
            const dateStr = row.ClockInTime;
            const dateObj = new Date(dateStr);
            const month = dateObj.toLocaleString("default", { month: "long" });
            const day = dateObj.getDate();
            const year = dateObj.getFullYear();

            const formattedDate = `${month}, ${day}, ${year}`;
            return formattedDate;
          },
        },
        {
          field: "ClockInTime",
          key: "b",
          title: "Clock In",
          renderBodyCell: ({ row }) => {
            const dateTimeString = row.ClockInTime;

            const date = new Date(dateTimeString);
            return date.toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            });
          },
        },
        {
          field: "ClockInLocation",
          key: "c",
          title: "Clock In Location",
        },

        {
          field: "Date",
          key: "aa",
          title: "Date Out",
          renderBodyCell: ({ row }) => {
            if (row.ClockOutTime) {
              const dateStr = row.ClockOutTime;
              const dateObj = new Date(dateStr);
              const month = dateObj.toLocaleString("default", {
                month: "long",
              });
              const day = dateObj.getDate();
              const year = dateObj.getFullYear();

              const formattedDate = `${month}, ${day}, ${year}`;
              return formattedDate;
            } else {
              return "";
            }
          },
        },

        {
          field: "ClockOutTime",
          key: "bb",
          title: "Clock Out",
          renderBodyCell: ({ row }) => {
            if (row.ClockOutTime) {
              const dateTimeString = row.ClockOutTime;

              const date = new Date(dateTimeString);
              return date.toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              });
            } else {
              return "";
            }
          },
        },
        {
          field: "ClockOutLocation",
          key: "x",
          title: "Clock Out Location",
        },
        {
          field: "WorkSchedule",
          key: "d",
          title: "Work Schedule",
          renderBodyCell: ({ row }) => {
            // //console.log(row);
            return <p class="">{row.WorkSchedule} hrs</p>;
          },
        },

        {
          field: "LoggedIn",
          key: "f",
          title: "Logged In",
          renderBodyCell: ({ row }) => {
            if (row.ClockInTime && row.ClockOutTime) {
              const date1 = new Date(row.ClockInTime);
              const date2 = new Date(row.ClockOutTime); // current date and time
              const diffInMs = date2.getTime() - date1.getTime();

              const totalSeconds = Math.floor(diffInMs / 1000);
              const hours = Math.floor(totalSeconds / 3600);
              const minutes = Math.floor((totalSeconds % 3600) / 60);

              return `${hours} hrs : ${minutes} mins`;
            } else {
              return "";
            }
          },
        },
        {
          field: "Overtime",
          key: "g",
          title: "Overtime",
          renderBodyCell: ({ row }) => {
            // //console.log(row);
            return row.Overtime ? (
              <p class="" style="color: green">
                {parseFloat(row.Overtime.toFixed(1))} hrs
              </p>
            ) : (
              row.Overtime + " hrs"
            );
          },
        },
        {
          field: "Deficit",
          key: "h",
          title: "Deficit",
          renderBodyCell: ({ row }) => {
            return row.Deficit ? (
              <p class="" style="color: #E85656">
                {parseFloat(row.Deficit.toFixed(1)) < 0
                  ? 0
                  : parseFloat(row.Deficit.toFixed(1))}{" "}
                hrs
              </p>
            ) : null;
          },
        },
      ],
      tableData: [],
    };
  },

  created() {
    this.getMyAttendance();
  },
  computed: {
    time() {
      return this.upadateTimeAfterOneSecond();
    },
    timeSinceClockIn() {
      return this.updateTimeElapsedSinceClockIn();
    },
    ...mapGetters([
      "getClockInTime",
      "isUseClockedIn",
      "getOrganization",
      "getToken",
      "getLatestClockInTimeWithoutClockout",
    ]),
  },

  methods: {
    getCurrentPosition() {
      return new Promise((resolve, reject) => {
        const rememberChoice = localStorage.getItem("rememberLocationChoice");

        if (rememberChoice === "allowed") {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        } else {
          navigator.permissions
            .query({ name: "geolocation" })
            .then((result) => {
              if (result.state === "granted") {
                resolve(result);
              } else {
                // You can customize the way you ask for permission here
                const userConsent = confirm(
                  "Allow the app to access your location?"
                );

                if (userConsent) {
                  localStorage.setItem("rememberLocationChoice", "allowed");
                  navigator.geolocation.getCurrentPosition(resolve, reject);
                } else {
                  reject("User denied location access");
                }
              }
            });
        }
      });
    },
    getMyAttendance() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/attendance/me/${this.$ApiVersion}/request`,
          options
        )
        .then(
          async (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;

              // alert(1);
              this.tableData = await Promise.all(
                this.tableData.map(async (row) => {
                  const clockIn = await this.fetchClockInLocations(row);
                  const clockOut = await this.fetchClockOutLocations(row);

                  return {
                    ...row,
                    ClockOutLocation: clockOut,
                    ClockInLocation: clockIn,
                  };
                })
              );
              this.getSummary(this.tableData);
              const latestClockInTimeWithoutClockout = this.tableData.find(
                (data) =>
                  data.ClockOutLatitude === null || data.ClockOutTime === null
              )?.ClockInTime;

              this.$store.commit(
                "setLatestClockInTimeWithoutClockout",
                latestClockInTimeWithoutClockout
              );
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          () => {
            this.loading = false;
          }
        );
    },

    getSummary(data) {
      const currentDate = new Date();
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());

      const endOfWeek = new Date(currentDate);
      endOfWeek.setDate(startOfWeek.getDate() + 6);

      const filteredData = data.filter((entry) => {
        const clockInTime = new Date(entry.ClockInTime);
        return clockInTime >= startOfWeek && clockInTime <= endOfWeek;
      });

      const totalDeficit = filteredData.reduce(
        (total, entry) => total + entry.Deficit,
        0
      );
      const totalOvertime = filteredData.reduce(
        (total, entry) => total + entry.Overtime,
        0
      );
      const totalLoggedTime = filteredData.reduce(
        (total, entry) => total + entry.LoggedIn,
        0
      );

      this.summary = [
        { name: "Work Schedule", value: "50 Hrs" },
        { name: "Logged Time", value: `${totalLoggedTime.toFixed(2)} Hrs` },
        {
          name: "Paid Time",
          value: `${(totalLoggedTime + totalOvertime).toFixed(2)} Hrs`,
        },
        { name: "Deficit", value: `${totalDeficit.toFixed(2)} Hrs` },
        { name: "Overtime", value: `${totalOvertime.toFixed(2)} Hrs` },
      ];
      console.log(this.summary);
    },

    upadateTimeAfterOneSecond() {
      setInterval(() => {
        this.currTime = moment().format("h:mm:ss A");
      }, 1000);
      return this.currTime;
    },
    async handleClockIn() {
      try {
        this.loading = true;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
        };

        if (navigator.geolocation) {
          const position = await this.getCurrentPosition();
          const { latitude, longitude } = position.coords;

          const response = await axios.post(
            `${this.getOrganization}/attendance/${this.$ApiVersion}/clockin`,
            {
              Location: {
                Latitude: latitude,
                Longitude: longitude,
              },
            },
            options
          );

          this.loading = false;

          if (response.data.StatusCode === 200) {
            this.success = response.data.StatusMessage;
            this.$store.commit("setClockIn", moment());
            this.getMyAttendance();
            setTimeout(() => {
              this.success = null;
            }, 5000);
          } else {
            this.create_error = response.data.StatusMessage;
            setTimeout(() => {
              this.create_error = null;
            }, 5000);
          }
        } else {
          this.create_error = "Geolocation is not supported by this browser.";
          setTimeout(() => {
            this.create_error = null;
          }, 5000);
        }
      } catch (error) {
        this.loading = false;
        this.create_error = "An error occurred while processing your request.";
        console.error("Clock-in error:", error);
        setTimeout(() => {
          this.create_error = null;
        }, 5000);
      }
    },

    async handleClockOut() {
      try {
        this.loading = true;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
        };

        if (navigator.geolocation) {
          const position = await this.getCurrentPosition();
          const { latitude, longitude } = position.coords;

          const response = await axios.post(
            `${this.getOrganization}/attendance/${this.$ApiVersion}/clockout`,
            {
              Location: {
                Latitude: latitude,
                Longitude: longitude,
              },
            },
            options
          );

          this.loading = false;

          if (response.data.StatusCode === 200) {
            this.success = response.data.StatusMessage;
            this.$store.commit("clockOut");
            this.getMyAttendance();
            setTimeout(() => {
              this.success = null;
            }, 5000);
          } else {
            this.create_error = response.data.StatusMessage;
            setTimeout(() => {
              this.create_error = null;
            }, 5000);
          }
        } else {
          this.create_error = "Geolocation is not supported by this browser.";
          setTimeout(() => {
            this.create_error = null;
          }, 5000);
        }
      } catch (error) {
        this.loading = false;
        this.create_error = "An error occurred while processing your request.";
        console.error("Clock-out error:", error);
        setTimeout(() => {
          this.create_error = null;
        }, 5000);
      }
    },

    updateTimeElapsedSinceClockIn() {
      setInterval(() => {
        this.timeElapsed = moment(this.getClockInTime).fromNow();
      }, 1000);
      return this.timeElapsed;
    },

    async getLocationName(lng, lat) {
      if (lng && lat) {
        const apiKey =
          "pk.eyJ1IjoiaGVybWl0ZXgiLCJhIjoiY2xldHNyc2JoMWFidjNycDExaWt1YXlzNyJ9.TVgjvCPzeZQbPHBXcDvcTg";
        try {
          const response = await axios.get(
            `https://api.mapbox.com/geocoding/v5/mapbox.places/${lat},${lng}.json?access_token=${apiKey}`
          );
          const location = response.data.features[0].place_name;
          const formattedLocation = location.substring(4).trim();
          return formattedLocation;
        } catch (err) {
          //console.log(err);
          return "";
        }
      } else return "";
    },
    async fetchClockInLocations(row) {
      return (this.clockInLocation = await this.getLocationName(
        row.ClockInLatitude,
        row.ClockInLongitude
      ));
    },
    async fetchClockOutLocations(row) {
      return (this.clockOutLocation = await this.getLocationName(
        row.ClockOutLatitude,
        row.ClockOutLongitude
      ));
    },
  },
};
</script>
